<app-title-bar titleText="i18n.core.navigation.editProfile"></app-title-bar>
<div class="row">
  <div class="col-lg-6 offset-lg-3 col-md-6 offset-md-3">
    <app-user-edit-form [userEditForm]="userEditForm"></app-user-edit-form>
  </div>
</div>
<div class="row">
  <div class="col-lg-6 offset-lg-3 col-md-6 offset-md-3">
    <button type="submit"
            class="btn btn-primary float-end"
            (click)="save()"
            [disabled]="!userEditForm.valid">
      {{ "i18n.shared.save" | translate }}
    </button>
  </div>
</div>
